import { logger } from '../utilites/logger';
import { getAppInsightsInitScript } from '../../_shared/utilites/AppInsightsInitScript';
import { injectScript } from '../../_shared/utilites/loadScript';
var AppInsightService = /** @class */function () {
  function AppInsightService() {}
  AppInsightService.init = function (instrumentationKey, uri, properties, screenResolution, connectionString) {
    var _this = this;
    var initScript = getAppInsightsInitScript(instrumentationKey, connectionString);
    injectScript(initScript).then(function () {
      _this.trackPageView(uri, properties, screenResolution);
    }).catch(function (error) {
      logger.error(error, 'error while initializing AppInsights');
    });
  };
  AppInsightService.trackAppError = function (error, adBlockEnabled, isUserLoggedIn, isUserSubscribed, info, isErrorBoundary) {
    if (info === void 0) {
      info = {};
    }
    if (isErrorBoundary === void 0) {
      isErrorBoundary = false;
    }
    var problemPagePath = window ? window.location.pathname : undefined;
    this.trackEvent('js-error', {
      error: error,
      info: JSON.stringify(info),
      page: problemPagePath,
      adBlockEnabled: adBlockEnabled,
      isUserLoggedIn: isUserLoggedIn,
      isUserSubscribed: isUserSubscribed,
      type: isErrorBoundary ? 'Something went wrong' : 'common'
    });
  };
  AppInsightService.trackPageView = function (uri, properties, screenResolution) {
    if (window.appInsightsArkadium) {
      window.appInsightsArkadium.trackPageView({
        name: document.title,
        uri: uri,
        properties: properties,
        screenResolution: screenResolution
      });
    }
  };
  AppInsightService.trackEvent = function (name, data) {
    if (window.appInsightsArkadium) {
      window.appInsightsArkadium.trackEvent({
        name: name,
        properties: data
      });
    }
  };
  AppInsightService.getAnalyticsData = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    if (window.appInsightsArkadium) {
      var AI = window.appInsightsArkadium;
      return {
        SessionId: (_a = AI === null || AI === void 0 ? void 0 : AI.context) === null || _a === void 0 ? void 0 : _a.getSessionId(),
        ParentId: (_c = (_b = AI === null || AI === void 0 ? void 0 : AI.context) === null || _b === void 0 ? void 0 : _b.telemetryTrace) === null || _c === void 0 ? void 0 : _c.parentID,
        OperationId: (_e = (_d = AI === null || AI === void 0 ? void 0 : AI.context) === null || _d === void 0 ? void 0 : _d.telemetryTrace) === null || _e === void 0 ? void 0 : _e.traceID,
        OperationName: (_g = (_f = AI === null || AI === void 0 ? void 0 : AI.context) === null || _f === void 0 ? void 0 : _f.telemetryTrace) === null || _g === void 0 ? void 0 : _g.name
      };
    }
  };
  return AppInsightService;
}();
export { AppInsightService };